module.exports = __webpack_public_path__ + "img/About-us-picture-for-home-page.1d98c36d.jpg";